$(function () {
    $('.menu-opener').click(function () {
       $('.home-menu').addClass('show');
       $('.menu-overlay').fadeIn();
    });
    $('.menu-closer').click(function () {
       $('.home-menu').removeClass('show');
        $('.menu-overlay').fadeOut();
    });


    if ($(window).width() < 769) {
       $('.projects-menu > ul > .current-menu-item').append('<i class="fa fa-chevron-right go-to-next-category"></i>');
       $('.projects-menu > ul > .current-menu-item').prepend('<i class="fa fa-chevron-left go-to-prev-category"></i>');

        $('.projects-menu > ul > .current-category-parent').append('<i class="fa fa-chevron-right go-to-next-category"></i>');
        $('.projects-menu > ul > .current-category-parent').prepend('<i class="fa fa-chevron-left go-to-prev-category"></i>');

        $('.projects-menu > ul > .current-post-parent').append('<i class="fa fa-chevron-right go-to-next-category"></i>');
        $('.projects-menu > ul > .current-post-parent').prepend('<i class="fa fa-chevron-left go-to-prev-category"></i>');

       $('.go-to-next-category').click(function () {
          var target = $(this).parent().next().find('a:first-child').attr('href');
          window.location = target;
       });

        $('.go-to-prev-category').click(function () {
            var target = $(this).parent().prev().find('a:first-child').attr('href');
            window.location = target;
        });
    }
});